import styled from 'styled-components'

export const Label = styled.div`
	display: flex;
	flex: 1 1 auto;
	min-width: 0;
	flex-direction: column;
	row-gap: 4px;
`
